import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
	fill?: string;
	height?: number;
	width?: number;
}

export const WebSiteIcon: React.FC<IProps> = props => {
	const { className, fill, height = 20, width = 20 } = props;
	return (
		<SvgIcon
			className={className ?? ''}
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill={fill}
			xmlns='http://www.w3.org/2000/svg'
		>
			<g id='Design' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g id='Group-2' fill='#C6CCD7'>
					<path
						d='M14,6.0005 L14,3.0835 C15.209,3.7845 16.216,4.7925 16.917,6.0005 L14,6.0005 Z M12,6.0005 L8,6.0005 L8,2.2635 C8.641,2.0975 9.309,2.0005 10,2.0005 C10.691,2.0005 11.359,2.0975 12,2.2635 L12,6.0005 Z M12,12.0005 L8,12.0005 L8,8.0005 L12,8.0005 L12,12.0005 Z M12,17.7375 C11.359,17.9035 10.691,18.0005 10,18.0005 C9.309,18.0005 8.641,17.9035 8,17.7375 L8,14.0005 L12,14.0005 L12,17.7375 Z M6,6.0005 L3.083,6.0005 C3.784,4.7925 4.791,3.7845 6,3.0835 L6,6.0005 Z M6,12.0005 L2.263,12.0005 C2.098,11.3595 2,10.6925 2,10.0005 C2,9.3085 2.098,8.6415 2.263,8.0005 L6,8.0005 L6,12.0005 Z M6,16.9185 C4.791,16.2165 3.784,15.2085 3.083,14.0005 L6,14.0005 L6,16.9185 Z M10,0.0005 C4.486,0.0005 0,4.4865 0,10.0005 C0,15.5145 4.486,20.0005 10,20.0005 C12.252,20.0005 14.326,19.2435 16,17.9815 L16,15.2495 C15.426,15.9055 14.759,16.4775 14,16.9185 L14,14.0005 L16,14.0005 L16,12.0005 L14,12.0005 L14,8.0005 L17.737,8.0005 C17.902,8.6415 18,9.3085 18,10.0005 C18,10.6925 17.902,11.3595 17.737,12.0005 L19.798,12.0005 C19.93,11.3545 20,10.6855 20,10.0005 C20,4.4865 15.514,0.0005 10,0.0005 L10,0.0005 Z'
						id='Fill-1841'
						transform='translate(10, 10.0005) rotate(90) translate(-10, -10.0005)'
					/>
					<path
						d='M14,6 L14,3.083 C15.209,3.784 16.216,4.792 16.917,6 L14,6 Z M12,6 L8,6 L8,2.263 C8.641,2.097 9.309,2 10,2 C10.691,2 11.359,2.097 12,2.263 L12,6 Z M12,12 L8,12 L8,8 L12,8 L12,12 Z M12,17.737 C11.359,17.903 10.691,18 10,18 C9.309,18 8.641,17.903 8,17.737 L8,14 L12,14 L12,17.737 Z M6,6 L3.083,6 C3.784,4.792 4.791,3.784 6,3.083 L6,6 Z M6,12 L2.263,12 C2.098,11.359 2,10.692 2,10 C2,9.308 2.098,8.641 2.263,8 L6,8 L6,12 Z M6,16.918 C4.791,16.216 3.784,15.208 3.083,14 L6,14 L6,16.918 Z M10,0 C4.486,0 0,4.486 0,10 C0,15.514 4.486,20 10,20 C12.252,20 14.326,19.243 16,17.981 L16,15.249 C15.426,15.905 14.759,16.477 14,16.918 L14,14 L16,14 L16,12 L14,12 L14,8 L17.737,8 C17.902,8.641 18,9.308 18,10 C18,10.692 17.902,11.359 17.737,12 L19.798,12 C19.93,11.354 20,10.685 20,10 C20,4.486 15.514,0 10,0 L10,0 Z'
						id='Fill-1841'
					/>
				</g>
			</g>
		</SvgIcon>
	);
};
